import React from "react";
import { Route, Switch } from "react-router-dom";
import PaymentLogsList from "./containers/payment-logs.list";

export default function PaymentLogsRoutes({ match }) {
    return (
        <Switch>
            <Route path={`${match.url}`} component={PaymentLogsList} />
        </Switch>
    );
}
